import {  
  TableCell,
  TableRow,
  } from '@material-ui/core';

  import React, { useState, useEffect, useRef } from 'react';
  import { PhasenDetails } from './PhasenDetails';



  export const PhasenListData = (props) => {
    
      
    let filterdatacenter = props.rawdata.datacenters.filter((item) => {
        return item.datacenterName === props.datacenterselect
      });

      let newArray = filterdatacenter[0].circuitConsumptions;

      //console.log(newArray)

    const formatnumber = (value) => {
        return value.toFixed(2)
      }; 
     
      

    return (
      <>
        {newArray.map((item, index) => (
                       <TableRow
                       hover
                       key={index}
                      >
                        <TableCell>
                          <h2>{item.circuitName}</h2>
                        </TableCell>
                        <TableCell>
                        {formatnumber(item.kWPower)} kW
                        </TableCell>
                        <TableCell>
                        {formatnumber(item.kWhDaily)} kWh
                        </TableCell>
                        <TableCell>
                         <PhasenDetails phaseConsumptions={item.phaseConsumptions}/>
                        </TableCell>
                    </TableRow> 
                ))}
       

        
      </>
    )
  }
